import { MEDIA_QUERIES } from "@constants"
import styled from "styled-components"

export const AuthorPageHeroHEADER = styled.header`
  margin: var(--spacing--M) 0 var(--spacing--L);

  .grid {
    overflow: hidden;
    border-radius: var(--border-radius--M) var(--border-radius--M) 0 0;
    background-image:
      linear-gradient(
        180deg,
        var(--color--slate-100) 0%,
        rgba(var(--color--slate-100-rgb), 0.99) 6.67%,
        rgba(var(--color--slate-100-rgb), 0.96) 13.33%,
        rgba(var(--color--slate-100-rgb), 0.92) 20%,
        rgba(var(--color--slate-100-rgb), 0.85) 26.67%,
        rgba(var(--color--slate-100-rgb), 0.77) 33.33%,
        rgba(var(--color--slate-100-rgb), 0.67) 40%,
        rgba(var(--color--slate-100-rgb), 0.56) 46.67%,
        rgba(var(--color--slate-100-rgb), 0.44) 53.33%,
        rgba(var(--color--slate-100-rgb), 0.33) 60%,
        rgba(var(--color--slate-100-rgb), 0.23) 66.67%,
        rgba(var(--color--slate-100-rgb), 0.15) 73.33%,
        rgba(var(--color--slate-100-rgb), 0.08) 80%,
        rgba(var(--color--slate-100-rgb), 0.04) 86.67%,
        rgba(var(--color--slate-100-rgb), 0.01) 93.33%,
        rgba(var(--color--slate-100-rgb), 0.00) 100%
      );
  }

  .image-column {
    position: relative;

    .gatsby-image-wrapper {
      mix-blend-mode: multiply;

      &::after,
      &::before {
        content: "";
        display: block;
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 1;
      }

      &::before {
        height: 100%;
        background: var(--color--slate-600);
        mix-blend-mode: screen;
      }

      &::after {
        height: 45%;
        background: linear-gradient(
          0deg,
          var(--color--basics-white) 0%,
          rgba(var(--color--basics-white-rgb), 0.99) 6.67%,
          rgba(var(--color--basics-white-rgb), 0.96) 13.33%,
          rgba(var(--color--basics-white-rgb), 0.92) 20%,
          rgba(var(--color--basics-white-rgb), 0.85) 26.67%,
          rgba(var(--color--basics-white-rgb), 0.77) 33.33%,
          rgba(var(--color--basics-white-rgb), 0.67) 40%,
          rgba(var(--color--basics-white-rgb), 0.56) 46.67%,
          rgba(var(--color--basics-white-rgb), 0.44) 53.33%,
          rgba(var(--color--basics-white-rgb), 0.33) 60%,
          rgba(var(--color--basics-white-rgb), 0.23) 66.67%,
          rgba(var(--color--basics-white-rgb), 0.15) 73.33%,
          rgba(var(--color--basics-white-rgb), 0.08) 80%,
          rgba(var(--color--basics-white-rgb), 0.04) 86.67%,
          rgba(var(--color--basics-white-rgb), 0.01) 93.33%,
          rgba(var(--color--basics-white-rgb), 0.00) 100%
        );
      }

      img {
        filter: saturate(0.05) contrast(1.3);
      }
    }

    .social-links {
      bottom: 0;
      display: flex;
      gap: var(--spacing--base-0-75);
      left: 0;
      padding: var(--spacing--XS);
      position: absolute;

      a {
        align-items: center;
        background: rgba(var(--color--slate-300-rgb), 0.5);
        border-radius: 50%;
        display: flex;
        justify-content: center;
        height: var(--button--padding-x-L);
        transition: background 0.3s;
        width: var(--button--padding-x-L);

        &:hover {
          background: var(--color--slate-300);
        }
      }
    }
  }

  .text-column {
    display: flex;
    flex-direction: column;
    gap: var(--spacing--M);
    padding: var(--spacing--L) var(--spacing--L) var(--spacing--M)  var(--spacing--M);

    ${MEDIA_QUERIES.M} {
      justify-content: space-between;
    }

    .bio {
      p {
        font-size: var(--font-size--L);
        margin-bottom: var(--text-L--margin-bottom);
        max-width: var(--max-width--column--6);

        &:last-of-type {
          margin-bottom: 0;
        }
      }
    }
  }
`
